import type React from 'react';
import { Step4Welcome } from './steps/step-4-welcome';

type Page = {
  Component: (props: { continueStep: () => void }) => React.JSX.Element;
  pageName: 'feedback' | 'welcome';
};

export const postPurchasePages: Array<Page> = [
  {
    Component: Step4Welcome,
    pageName: 'welcome',
  },
];
